import type { QueryClient } from '@tanstack/react-query'
import isNull from 'lodash/isNull'

class QueryClientRegistry {
    private _client: QueryClient | null = null

    registerClient(client: QueryClient): void {
        this._client = client
    }

    getClient(): QueryClient | null {
        return isNull(this._client) ? null : this._client
    }
}

export default new QueryClientRegistry()
